import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { DashedText } from "./DashedText";

export const StandardLink: React.FC<
  PropsWithChildren<{
    to?: string | null;
    className?: string;
  }>
> = ({ to, children, className }) => {
  if (!to) return null;

  return (
    <Link
      to={to}
      className={classNames(className, "h4 text-hyacinth")}
      aria-label={`Go to page ${to}`}
    >
      <DashedText>{children}</DashedText>
    </Link>
  );
};
